import { render } from "./LightGallery.vue?vue&type=template&id=47173610&ts=true"
import script from "./LightGallery.vue?vue&type=script&lang=ts"
export * from "./LightGallery.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/sachinn/workspace/projects/lightgallery/plugin/lightgallery-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__